import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  background: ${({ theme }) => theme.THEME.background};
  padding: 24px;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CropperWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
`;

export const SliderWrapper = styled.div`
  margin: 20px 0;
  width: 80%;

  input {
    width: 100%;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`;

export const CancelButton = styled.button`
  background: transparent;
  color: ${({ theme }) => theme.THEME.white};
  border: 1px solid ${({ theme }) => theme.THEME.neonPink};
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
`;

export const ConfirmButton = styled.button`
  background: ${({ theme }) => theme.THEME.neonPink};
  color: ${({ theme }) => theme.THEME.black};
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
`;

export const AspectButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 320px;
  margin: 0 auto 16px auto;
`;

export const AspectButton = styled.button<{ $active?: boolean }>`
  flex: 1;
  padding: 10px 12px;
  border-radius: 10px;
  background: transparent;
  font-weight: 500;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  color: ${({ theme }) => theme.THEME.white};
  cursor: pointer;
  transition: 0.2s ease;
  border: ${({ $active, theme }) =>
    $active
      ? `2px solid ${theme.THEME.neonBlue}`
      : `1px solid ${theme.THEME.white}`};

  &:hover {
    border-color: ${({ theme }) => theme.THEME.neonBlue};
    box-shadow: 0 0 8px rgba(0, 217, 255, 0.25);
  }

  ${({ $active, theme }) =>
    $active &&
    `
    background: ${theme.THEME.neonBlue};
    color: ${theme.THEME.black};
    box-shadow: 0 0 12px rgba(0, 217, 255, 0.5);
  `}

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 217, 255, 0.35);
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 5}px;
  }
`;
